import { useLanguage } from '../context/LanguageContext';

export default function EnvironmentBadge() {
  const { t } = useLanguage();
  if (process.env.REACT_APP_ENVIRONMENT !== 'testing') return null;
  return <div role="status" style={{ position: 'fixed', bottom: 12, left: '50%', transform: 'translateX(-50%)', zIndex: 9999, background: '#c9a84c', color: '#080810', padding: '6px 14px', borderRadius: 8, fontFamily: "'DM Sans',sans-serif", fontSize: 12, fontWeight: 700, pointerEvents: 'none' }}>{t('common.testingEnvironment')}</div>;
}
